// src/features/legacy-reports/useLegacyMediasDetailReport.ts

import { useQuery } from '@tanstack/react-query';
import { LegacyReportsApi } from './LegacyReportsApi';
import {
  LEGACY_REPORTS_QUERY_KEYS,
  legacyMediaIdsKey,
} from '@/lib/constants/legacyReports';
import type { LegacyMediasDetailReport } from './types';

export interface UseLegacyMediasDetailReportResult {
  report: LegacyMediasDetailReport | null;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

/** Legacy media drill-down. Enabled only while a media row is expanded. */
export function useLegacyMediasDetailReport(
  cId: number | null,
  start: number,
  end: number,
  mediaIds: number[] | null
): UseLegacyMediasDetailReportResult {
  const query = useQuery({
    queryKey: LEGACY_REPORTS_QUERY_KEYS.mediasDetail(
      cId ?? 0,
      start,
      end,
      legacyMediaIdsKey(mediaIds)
    ),
    queryFn: () => LegacyReportsApi.getMediasDetailReport(cId!, start, end, mediaIds!),
    enabled: cId !== null && mediaIds !== null && mediaIds.length > 0,
  });

  return {
    report: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
